export default "__VITE_ASSET__da707152__"